import  { useState ,useEffect} from 'react';
import {Subsription,Loader} from "../components";
import { useNavigate } from 'react-router-dom';
import {SubscriptionResponseText as text ,modalText as modal} from "../database/SubscriptionText";
import { useMainContext } from '../callContext/MainContext';
import sad from "../assets/icons/smiley.png";
import happy from "../assets/icons/smiley2.png";
import axios from 'axios';
import config, { getHeaders } from '../config';

const SubscriptionResponseModal = () => {
  const navigate=useNavigate();
  const [loading,setLoading]=useState(false);
  const modalType=localStorage.getItem("modalType");
  const pack=localStorage.getItem("selectedPack")?JSON.parse(localStorage.getItem("selectedPack")):null;
  const {language}=useMainContext();
  const message=localStorage.getItem("message");
  const msg1=localStorage.getItem("msg1");
  const msg2=localStorage.getItem("msg2");
  const msisdn=localStorage?.getItem("msisdn")
  const subscribe = async () => {
    if(msisdn && (msisdn!=="undefined" || msisdn!==undefined))
      {
  
    setLoading(true);
    const url = `${config.get("base")}${config.get("subscribe")}`;
    const headers={
      ...getHeaders(),
       Language:language,
       camp : sessionStorage.getItem("campId"),
       rcid : sessionStorage.getItem("rcid")
    }
    const body={
    "msisdn":localStorage?.getItem("msisdn"),
    "Packtype": pack?.packType
  }
    await axios.post( url,body, {headers: headers} )
      .then((result) => {
        console.log("result message appConfig ::", result);
        setLoading(false);
        localStorage.setItem("modalType",result.data.subStatus);
        if(result?.data?.uid)
          {
            localStorage.setItem("uid", result?.data?.uid);
          }
        localStorage.setItem("msg1", result?.data?.msg1);
        localStorage.setItem("msg2", result?.data?.msg2);
        localStorage.setItem("msg3", result?.data?.msg3);
        localStorage.setItem("message", result?.data?.message);   
          
      })
      .catch((error) => {
        console.log("error is:::", error);
      })
    }
    else
    {
      console.log("msisdn is not found")
    }
  };
  const handleOkClick=()=>{
    if(modalType==="active")
      {
        console.log("here")
       
          navigate("/home")
     }
     else if(modalType==="failed" || modalType==="failure")
      {
          window.location.reload();
      } 
    else if(modalType==="confirm")
         {
              subscribe();
         } 
    else 
        {
          navigate("/subs/packs")
        }
  }
  useEffect(()=>
  {
     return ()=>localStorage.removeItem("modalType")
  },[])
    if(loading) return <Loader/>;

 
  return (
    <Subsription>
      <div className='flex flex-col justify-evenly items-center my-1'>
         <img src={["active","confirm",'pending'].includes(modalType)?happy:sad}
          alt="happy"
          className={`${["active","confirm",'pending'].includes(modalType)?'h-16':'h-28'} my-2`}/>
      <h1 className='text-center text-red-500 font-medium text-2xl px-4 my-4'>
      {["confirm"].includes(modalType)?<span>{modal?.confirmModalText?.[language]} </span>:
      <span>{message}</span>}</h1>
      {!["grace",'failed',"undefined","pending"].includes(modalType) &&  
      <>
      <h3 className='text-center pb-3 text-bold'>
       {msg1 || text?.modalText[language]}
      </h3>
      {modalType!=='pending' &&<button className='p-2 rounded-full text-lg px-4 my-2 bg-red-500 font-bold text-white' 
      onClick={handleOkClick}>
        {text?.buttonText?.[language]}
      </button>}
      
      </>
      }
      {
        modalType==="pending" &&
        <h3 className='text-center pb-3 text-bold text-red-500 px-6'>
       {msg1} 
       <span className='text-black'>{" "} {msg2}</span>
      </h3>
      }
      </div>
   </Subsription>
  )
}

export default SubscriptionResponseModal